// MARK: React
import * as React from "react";

// MARK: Components
import { IconButton as MIconButton } from "@material-ui/core";

// MARK: Iconst
import { Close as MCloseIcon } from "@material-ui/icons";

interface IProps {
	close: () => void;
}

export default class CloseFloatingBtn extends React.Component<IProps> {
	public render() {
		const { close } = this.props;
		return (
			<MIconButton
				onClick={close}
				style={{ position: "fixed", alignSelf: "flex-end", padding: "0", fill: "grey" }}
			>
				<MCloseIcon />
			</MIconButton>
		);
	}
}
